import { API_CALL_ERROR } from './../../../store/action';
import { AppInjector } from './../../../app-injector';
import {
  FETCH_PRODUCT_DETAIL_REQUESTED,
  FETCH_PRODUCT_DETAIL_SUCCEEDED,
  FETCH_PRODUCT_TEMPORARY_PRICE_REQUESTED,
  FETCH_PRODUCT_TEMPORARY_PRICE_SUCCEEDED,
  FETCH_PRODUCT_ALLOWED_TRANSITIONS_REQUESTED,
  FETCH_PRODUCT_ALLOWED_TRANSITIONS_SUCCEEDED,
  FETCH_PRODUCT_HISTORIES_REQUESTED,
  FETCH_PRODUCT_HISTORIES_SUCCEEDED
} from "./detail.actions";
import {takeEvery, put, all} from "redux-saga/effects";
import { ApiService } from '../../../api/api.service';

function* getProductDetail(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.getItemById(action.data).toPromise();
    // console.log(result);
    yield put({ type: FETCH_PRODUCT_DETAIL_SUCCEEDED, data: result });
    // all product histories
    if (!action.no_relation) {
      yield all([
        put({ type: FETCH_PRODUCT_TEMPORARY_PRICE_REQUESTED, id: action.data, filter: {onlyActive: true}, sort: ['sort', '-created_at'] }),
        put({ type: FETCH_PRODUCT_ALLOWED_TRANSITIONS_REQUESTED, id: action.data, filter: {onlyActive: true}, sort: ['sort'] }),
        put({ type: FETCH_PRODUCT_HISTORIES_REQUESTED, id: action.data, data_type: 'process_status_id' }),
        put({ type: FETCH_PRODUCT_HISTORIES_REQUESTED, id: action.data, data_type: 'enabled' }),
        put({ type: FETCH_PRODUCT_HISTORIES_REQUESTED, id: action.data, data_type: 'price' }),
        put({ type: FETCH_PRODUCT_HISTORIES_REQUESTED, id: action.data, data_type: 'original_price' })
      ]);
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchProductDetailRequest() {
  yield takeEvery(FETCH_PRODUCT_DETAIL_REQUESTED, getProductDetail);
}

function* getTemporaryPriceFromProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.getTemporaryPrices(action.id, action.filter, action.sort).toPromise();
    yield put({ type: FETCH_PRODUCT_TEMPORARY_PRICE_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchTemporaryPriceRequest() {
  yield takeEvery(FETCH_PRODUCT_TEMPORARY_PRICE_REQUESTED, getTemporaryPriceFromProduct);
}

function* getAllowedTransitionsFromProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.getAllowedTransitions(action.id).toPromise();
    yield put({ type: FETCH_PRODUCT_ALLOWED_TRANSITIONS_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllowedTransitionsRequest() {
  yield takeEvery(FETCH_PRODUCT_ALLOWED_TRANSITIONS_REQUESTED, getAllowedTransitionsFromProduct);
}

function* getProductHistoriesFromProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.getHistories(action.id, action.data_type).toPromise();
    yield put({ type: FETCH_PRODUCT_HISTORIES_SUCCEEDED, data: result, data_type: action.data_type });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchProductHistoriesRequest() {
  yield takeEvery(FETCH_PRODUCT_HISTORIES_REQUESTED, getProductHistoriesFromProduct);
}

export default [
  watchFetchProductDetailRequest,
  watchFetchTemporaryPriceRequest,
  watchFetchAllowedTransitionsRequest,
  watchFetchProductHistoriesRequest
];
